var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTransactionSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FEE2B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4731 9.46201H18.7304C19.052 9.46201 19.2722 9.79226 19.1526 10.0953L18.7309 11.3096H14.182L13.7603 10.0953C13.6407 9.79226 13.8609 9.46201 14.1825 9.46201H15.4384C15.6883 9.17845 16.0515 9 16.4558 9C16.86 9 17.2232 9.17845 17.4731 9.46201Z",
    fill: "#E05E22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7331 12.2332H14.1842C14.1842 12.2332 11 15.0045 11 18.2377C11 20.0852 12.3647 21.009 13.2744 21.009H16.4586H19.6429C20.5526 21.009 21.9173 20.0852 21.9173 18.2377C21.9173 15.0045 18.7331 12.2332 18.7331 12.2332ZM16.6089 15.8723C17.1388 15.978 17.8681 16.1235 17.8681 16.8872C17.8681 17.3892 17.5055 17.8262 16.785 17.9517V18.4677H16.1295V17.9749C15.6647 17.947 15.2138 17.8215 14.9348 17.6495L15.2881 16.85C15.5949 17.0313 16.004 17.1475 16.362 17.1475C16.6734 17.1475 16.785 17.0824 16.785 16.9708C16.785 16.8206 16.5422 16.77 16.235 16.7061C15.706 16.596 14.986 16.4461 14.986 15.6785C14.986 15.1532 15.3672 14.7116 16.1295 14.6047V14.098H16.785V14.5954C17.129 14.6279 17.4637 14.7162 17.7287 14.865L17.3986 15.6599C17.0779 15.4972 16.7757 15.4182 16.4921 15.4182C16.1714 15.4182 16.0691 15.5112 16.0691 15.6227C16.0691 15.7646 16.3066 15.812 16.6089 15.8723Z",
    fill: "#E05E22"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTransactionSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/transactionSuccess.fec75794ba225f3e3f8e1e0a6e295e63.svg";